import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BbSelectOption } from '../components/shared/bb-select/bb-select.component';

@Injectable()
export class AdServicesService {
	public datePresets: BbSelectOption[] = [
		{value: 'custom', label: this.translate.instant('CUSTOM')},
		{value: 'today', label: this.translate.instant('TODAY')},
		{value: 'yesterday', label: this.translate.instant('YESTERDAY')},
		{value: 'last-24-hours', label: this.translate.instant('LAST_X_HOURS', { x: '24' }) },
		{value: 'last-48-hours', label: this.translate.instant('LAST_X_HOURS', { x: '48' }) },
		{value: 'last-72-hours', label: this.translate.instant('LAST_X_HOURS', { x: '72' }) },
		{value: 'last-7-days', label: this.translate.instant('LAST_X_DAYS', { x: '7' }) },
		{value: 'last-30-days', label: this.translate.instant('LAST_X_DAYS', { x: '30' }) },
		{value: 'last-6-months', label: this.translate.instant('LAST_6_MONTHS') },
		{value: 'week-to-date', label: this.translate.instant('WEEK_TO_DATE') },
		{value: 'last-week', label: this.translate.instant('LAST_WEEK') },
		{value: 'month-to-date', label: this.translate.instant('MONTH_TO_DATE') },
		{value: 'last-month', label: this.translate.instant('LAST_MONTH') },
		{value: 'quarter-to-date', label: this.translate.instant('QUARTER_TO_DATE') },
		{value: 'last-quarter', label: this.translate.instant('LAST_QUARTER') },
		{value: 'year-to-date', label: this.translate.instant('YEAR_TO_DATE') },
		{value: 'last-year', label: this.translate.instant('LAST_YEAR') },
	];

	constructor(private translate: TranslateService) {
	}
}
